import axios from 'axios';
import qs from 'querystring';
import { responseHandler } from './response';

export const postWithoutHeader = async function (url, params) {
  let res = await axios.post(url, qs.stringify(params));
  return responseHandler(res);
};

/**
 * 普通post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const post = async function (url, params, isCatch) {
  let res = cached(params);
  if (res && isCatch) {
    return responseHandler(res);
  }
  res = await axios.post(url, qs.stringify(params), {
    headers: {
      'Ovo-Authorization': await ccutils.getOvoAuthenticator(),
    },
  });
  if (isCatch) {
    cached(params, res);
  }
  return responseHandler(res);
};

export const get = async (url, params, isCatch) => {
  let res = cached(params);
  if (res && isCatch) {
    return responseHandler(res);
  }
  res = await axios.get(url, {
    params,
    headers: {
      'Ovo-Authorization': await ccutils.getOvoAuthenticator(),
    },
  });
  if (isCatch) {
    cached(params, res);
  }
  return responseHandler(res);
};

/**
 * json格式的Post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const postJson = async function (url, params, isCatch) {
  let res = cached(params);
  if (res && isCatch) {
    return responseHandler(res);
  }
  res = await axios.post(url, params, {
    headers: {
      'Content-Type': 'application/json',
      'Ovo-Authorization': await ccutils.getOvoAuthenticator(),
    },
  });
  if (isCatch) {
    cached(params, res);
  }
  return responseHandler(res);
};

/**
 * 上传文件
 * @param url
 * @param params
 * @returns {*}
 */
export const postFile = async function (url, formdata) {
  let res = await axios({
    url: url,
    method: 'post',
    data: formdata,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Ovo-Authorization': await ccutils.getOvoAuthenticator(),
    },
  });
  return responseHandler(res);
};

/**
 * 文件流
 */
export const exportFile = async function (url, params) {
  let res = await axios.post(url, qs.stringify(params), {
    headers: {
      'Ovo-Authorization': await ccutils.getOvoAuthenticator(),
    },
    responseType: 'blob',
  });
  return res;
};

/**
 * 多个请求并行发送
 * @param methods
 * @returns {Promise}
 */
/*export const postAll = function (...methods) {
    return new Promise((resolve, reject) => {
        axios.all(...methods).then(axios.spread((res1,res2) => {
          console.log(res1)
          //  resolve(...res);
        })).catch(e=>reject(e));
    });
};*/

export let mapCatch = new Map();
function cached(params, res) {
  let key = typeof params === 'string' ? params : JSON.stringify(params);
  if (mapCatch.has(key)) {
    return mapCatch.get(key);
  } else if (res) {
    mapCatch.set(key, res);
  }
  return false;
}
